import styled from 'styled-components';
import { ApButtonMain, ApModal } from '@alixpartners/ui-components';
import { chartJaffaOrange } from 'styles/colors';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: ${colors.grey1};
`;

export const Subheader = styled.div`
	width: 100%;
	min-height: 48px;
	height: 48px;
	display: flex;
	border-bottom: 1px solid ${colors.amber};
	align-items: center;
	padding: 0 32px;
	background-color: white;
`;

export const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: auto;
	padding: 32px;
	background-color: ${colors.grey1};
`;

export const InnerContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 32px;
	background-color: white;
`;

export const Section = styled.section`
	width: 100%;
	display: flex;
	border-bottom: 1px solid ${colors.grey2};
	padding: 32px 0;

	&:first-child {
		padding-top: 0;
	}

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}
`;

export const SectionLabel = styled.section`
	width: 325px;
	min-width: 325px;
	margin-right: 32px;
`;

export const SectionContent = styled.section`
	width: 100%;
	overflow: hidden;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	flex: 1;
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 16px;
	align-self: center;
`;

export const SubTitle = styled.div`
	font-weight: 500;
	font-size: 19px;
	line-height: 27px;
	color: ${colors.grey8};
	padding-bottom: 8px;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const Description = styled.div`
	color: ${colors.grey6};
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
`;

export const SaveButton = styled(ApButtonMain)`
	margin-left: 40px;
	background: ${colors.amber} !important;

	&:hover {
		background: ${chartJaffaOrange} !important;
	}
`;

export const Text = styled.div`
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
`;

export const StyledModal = styled(ApModal)`
	.ap-modal-content {
		max-width: 480px;
	}

	.ap-modal-header {
		border-bottom: none;
		padding: 27px 32px 8px 32px;
	}

	.ap-modal-footer {
		padding: 13px 32px 12px 32px;
	}

	.ap-modal-body {
		padding: 16px 32px 40px 32px;
	}
`;

export const ModalBody = styled.div`
	color: ${colors.grey8};
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 24px;
`;

export const ModalHeader = styled.div`
	color: ${colors.grey8};
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
`;
